'use strict';

/**
 *
 * @name: apiSplashscreenAdService
 *
 */

function ApiSplashscreenAdService($rootScope, $http) {

  'ngInject';

  /**
   *
   * @PUBLIC
   *
   */

  function get() {
    var target = $rootScope.apiUrlNew + '/splashscreen-ad/current';

    return $http.get(target);
  }
  /**
   *
   * @PRIVATE
   *
   */

  return {
    get
  };
}

export default ApiSplashscreenAdService;



// WEBPACK FOOTER //
// ./app/components/_api/splashscreen-ad.service.js